import {NzUploadXHRArgs} from 'ng-zorro-antd/upload';
import {Subscription} from 'rxjs';


export function getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
}

// export function getSafeImageUrl(url: string | undefined): string {
//   if (!url?.includes('/') || !url?.includes('.')) {
//     return 'assets/images/partner_avatar_placeholder.png'
//   }
//   return url || 'assets/images/partner_avatar_placeholder.png';
// }
export const getSafeImageUrl = (source: unknown): string => {
  if (source instanceof File) return URL.createObjectURL(source);

  if (typeof source === 'string' && source) {
    return source; // Confiamos que es una URL válida
  }

  return 'assets/images/partner_avatar_placeholder.png';
};

// Función para convertir una URL a base64
export async function getBase64ImageFromUrl(url: string): Promise<string> {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// Metodo para prevenir el error en el navegador de una peticion erronea del nz-upload
export function customUpload(item: NzUploadXHRArgs): Subscription {
  // Simula un retardo (opcional)
  setTimeout(() => {
    // Llama al callback de éxito para que nz-upload marque el archivo como subido
    item.onSuccess!({}, item.file, null);
  }, 0);
  // Retorna una suscripción vacía, ya que no se está haciendo una petición real
  return new Subscription();
}
